import { render, staticRenderFns } from "./swipetopay.vue?vue&type=template&id=5ab25112&"
import script from "./swipetopay.vue?vue&type=script&lang=js&"
export * from "./swipetopay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports